import * as Cookies from 'js-cookie';
import config from '../config';
import axios from 'axios';
import { getUserDetails } from '@nexxt/common/firebase/auth/userDetails';
import { PortalSession } from '../constants/project';

/**
 * Loads Session, returns session object
 */
export const loadSession = async (): Promise<{ data: PortalSession }> => {
    // change return type
    let res;
    const user = getUserDetails();
    try {
        const DATA_API_URL = `${config.host.data}/session/load/portal/${user.id}`;
        const cssToken = Cookies.get('csst');
        const signal = axios.CancelToken.source();
        res = await axios.get(DATA_API_URL, {
            cancelToken: signal.token,
            headers: { Authorization: `Bearer ${cssToken}` },
            withCredentials: true
        });
    } catch (error) {
        console.log('ERROR! Could not load session:', error);
    }
    return res;
};

/**
 * Saves session
 */
export const saveSession = async (newSession): Promise<void> => {
    const user = getUserDetails();
    const DATA_API_URL = `${config.host.data}/session/save`;
    const signal = axios.CancelToken.source();
    const body = {
        sessionKey: user.id,
        sessionContext: 'portal',
        sessionObject: newSession
    };
    try {
        const cssToken = Cookies.get('csst');
        await axios.post(DATA_API_URL, body, {
            cancelToken: signal.token,
            headers: { Authorization: `Bearer ${cssToken}` },
            withCredentials: true
        });
    } catch (error) {
        console.log('ERROR! Could not save session:', error);
    }
};
